import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const equipmentDevolutionObject = z.object({
  id: z.string().uuid(),
  equipmentId: z.string().uuid(),
  loanId: z.string().uuid(),
  citizenId: z.string().uuid(),
  observation: z.string().nullish(),
  devolutionDate: dateOrIsoString(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
})

export type EquipmentDevolutionType = z.infer<typeof equipmentDevolutionObject>

export const propertyMap = {
  id: sql`equipment_devolution.id`,
  equipmentId: sql`equipment_devolution.equipment_id`,
  loanId: sql`equipment_devolution.loan_id`,
  citizenId: sql`equipment_devolution.citizen_id`,
  observation: sql`equipment_devolution.observation`,
  devolutionDate: sql`equipment_devolution.devolution_date`,
  createdAt: sql`equipment_devolution.created_at`,
  updatedAt: sql`equipment_devolution.updated_at`,
}

export default equipmentDevolutionObject
